import React from 'react'
import ReactDOM from 'react-dom'
import Flickity from 'flickity'
import 'flickity/dist/flickity.min.css'

class Slider extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      flickityReady: false
    }

    this.refreshFlickity = this.refreshFlickity.bind(this)
  }

  componentDidMount() {
    this.flickity = new Flickity(this.flickityNode, this.props.options || {})

    this.setState({
      flickityReady: true
    })

    setTimeout(() => {
      //If images loading
      this.flickity.element.querySelectorAll('img').forEach(element => {
        element.addEventListener('load', () => {
          this.refreshFlickity()
        })
      })

      //If images already loaded (cached)
      this.refreshFlickity()
    }, 500)
  }

  refreshFlickity() {
    this.flickity.reloadCells()
    this.flickity.resize()
    this.flickity.updateDraggable()
  }

  componentWillUnmount() {
    // TODO: this causes React Router to basically implode if uncommented
    // TODO: not sure why, but this ends up causing React DOM to try to remove a child twice,
    // TODO: which of course, breaks the whole site...
    // this.flickity.destroy()
  }

  componentDidUpdate(prevProps, prevState) {
    const flickityDidBecomeActive =
      !prevState.flickityReady && this.state.flickityReady
    const childrenDidChange =
      prevProps.children.length !== this.props.children.length

    if (flickityDidBecomeActive || childrenDidChange) {
      this.refreshFlickity()
    }
  }

  renderPortal() {
    if (!this.flickityNode) {
      return null
    }

    const mountNode = this.flickityNode.querySelector('.flickity-slider')

    if (mountNode) {
      return ReactDOM.createPortal(this.props.children, mountNode)
    }
  }

  render() {
    return [
      <div
        className={'test'}
        key="flickityBase"
        ref={node => (this.flickityNode = node)}
      />,
      this.renderPortal()
    ].filter(Boolean)
  }
}

export default Slider



// WEBPACK FOOTER //
// ./src/Components/Slider.js